<template>
    <van-collapse v-model="activate">
        <div style="text-align: center">
            <div v-for="(item,index) in images">
                <van-collapse-item v-if="item.items.data.length > 0" :title="item.groupName" :name="index">
                    <van-row>
                        <van-col span="8" v-for="(itemImg,index) in item.items.data">
                            <img v-if="itemImg.fileFormat == '2' " src="../../../../assets/home/ic_file.png" width="100" height="100"
                                 style="margin-left: 5px;" />

                            <img v-else="itemImg.fileFormat == '2' ":src="itemImg.pictureRsUrl" width="100" height="100"
                                 style="margin-left: 5px;" @click="showImage(item.items.data,index)"/>
                        </van-col>
                    </van-row>
                </van-collapse-item>
            </div>
        </div>
    </van-collapse>
</template>

<script>
    import {ImagePreview} from 'vant'
    import {getForeClousureFileList} from '@/api/loanInfo'
    import icFile from '@/assets/home/ic_file.png'
    export default {
        name: 'investigation',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                activate: [],
                images: []
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            initData() {
                this.images = []
                this.getFileList("4")
            },
            getFileList(tabType){
                let params = {
                    applyId: this.applyId,
                    pictureType: '2',
                    tabType: tabType
                }
                getForeClousureFileList(params).then(res => {
                    if (res.success) {
                        this.images = this.images.concat(res.data)
                    }
                })
            },
            showImage(data, position) {
                let imgs = []
                data.forEach(item => {
                    if(item.fileFormat == '1'){
                        imgs.push(item.pictureRsUrl)
                    }
                })
                const instance = ImagePreview({
                    images: imgs,
                    lazyLoad: true,
                    startPosition: typeof position === 'number' ? position : 0
                })
            }
        }
    }
</script>

<style scoped>

</style>
